import { GET_SALON_SETTING } from '../constants';
import { getContent } from '../../services/api';
// import { fixedFetch } from '../../utils';
// const url = 'http://localhost:3001/mock/salonSetting.json';
const fetchSalonSetting = locale => ({
  type: GET_SALON_SETTING,
  payload: getContent({ contentType: 'salonSetting', locale }),
  // payload: fixedFetch(url),
});

export default fetchSalonSetting;


// WEBPACK FOOTER //
// ./src/redux/actions/salonSetting.js